import { Box, Button, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { FREE_CREDITS_HISTORY_INLINE_LIMIT } from '../../../controllers';
import { FreeCreditsHistoryViewModel } from '../../../types';
import FreeCreditsHistoryDialog from './FreeCreditsHistoryDialog';
import { FreeCreditsHistoryTable } from './FreeCreditsHistoryTable';

const FreeCreditsHistoryView: FC<FreeCreditsHistoryViewModel> = ({
  company,
  loading,
  failed,
  entries,
  count,
  sort,
  onSortChange,
  onRetry,
  isDialogOpen,
  onOpenDialog,
  onCloseDialog,
}) => {
  if (loading && entries.length === 0) return null;

  return (
    <Box sx={{ marginTop: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="body2" fontWeight="fontWeightSemiBold" sx={{ marginBottom: 1 }}>
          History
        </Typography>
        {count > FREE_CREDITS_HISTORY_INLINE_LIMIT && (
          <Button size="small" onClick={onOpenDialog}>
            View all ({count.toLocaleString()})
          </Button>
        )}
      </Stack>
      {entries.length > 0 && (
        <FreeCreditsHistoryTable
          entries={entries}
          timezone={company.timezone}
          sorting={{ value: sort, onChange: onSortChange }}
        />
      )}
      {entries.length === 0 && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ marginTop: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {failed ? 'Failed to load the history' : 'No changes yet'}
          </Typography>
          {failed && (
            <Button size="small" onClick={onRetry} disabled={loading}>
              Try again
            </Button>
          )}
        </Stack>
      )}
      <FreeCreditsHistoryDialog open={isDialogOpen} company={company} onClose={onCloseDialog} />
    </Box>
  );
};

export default FreeCreditsHistoryView;
